module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [(_vm.consents && _vm.consents.length > 0) ? _c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "grey lighten-5"
  }, [_c('v-tabs-slider', {
    staticClass: "accent"
  }), _vm._v(" "), _vm._l((_vm.tabs), function(tab) {
    return _c('v-tabs-item', {
      key: tab,
      attrs: {
        "ripple": "",
        "href": '#' + tab
      }
    }, [_vm._v("\n                            " + _vm._s(tab) + "\n                        ")])
  })], 2)], 1), _vm._v(" "), _vm._l((_vm.consents), function(item, index) {
    return _c('v-list-tile', {
      key: _vm.key(item),
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      class: item.Status
    }, [_vm._v("fa-code-fork")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.Intent.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.format(item.Expiration)))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "visible-hover"
    }, [_vm._v("mode_edit")])], 1)], 1)
  })], 2)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d36ff366","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Consents.vue
// module id = 397
// module chunks = 0